import React from 'react';
import { Pane, Text, TextArea } from '@leverege/ui-elements';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function Detail(props) {
  const {
    id,
    label,
    value,
    hint,
    onChange
  } = props;
  return /*#__PURE__*/_jsxs(Pane, {
    layout: "flex:colSpaceBetween",
    children: [/*#__PURE__*/_jsx(Text, {
      variant: "bodySmallBold",
      style: {
        fontSize: '13px',
        fontWeight: 600
      },
      children: label
    }), /*#__PURE__*/_jsx(TextArea, {
      style: {
        height: '104px',
        resize: 'none'
      },
      eventData: id,
      onChange: onChange,
      value: value,
      hint: hint
    })]
  });
}